import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { type DeviceTypeRecord } from "../DeviceTypeRecord";

import { deviceTypeQueryKeys } from "./deviceTypeQueryKeys";

/** The device type `deviceTypeId` of org `orgId`; disabled until both are known. */
export function useDeviceType(
  deviceTypeId: string | null | undefined,
  orgId: string | undefined,
) {
  const { deviceTypes } = useDomainServices();

  return useQuery<DeviceTypeRecord, Error>({
    queryKey: deviceTypeQueryKeys.detail(deviceTypeId ?? undefined),
    queryFn: ({ signal }) => {
      if (!deviceTypeId || orgId === undefined) {
        return Promise.reject(new Error("Invalid deviceTypeId or orgId"));
      }
      return deviceTypes.getDeviceType(deviceTypeId, {
        resourceOwnerId: orgId,
        abortSignal: signal,
      });
    },
    enabled: Boolean(deviceTypeId) && orgId !== undefined,
  });
}
